import _extends from "@babel/runtime/helpers/extends";
import { Box, Divider, Text, TextButton } from '@wix/design-system';
import React from 'react';
import { useShowsMonthlyUpsellNote } from '../../hooks/useShowsMonthlyUpsellNote';
import { TWO_YEAR_CYCLE_ID, YEARLY_CYCLE_ID } from '../../utils/consts';
import { useCurrentModule } from '../ModuleProvider';
import { MonthlyCycleUpsellHelper } from './MonthlyCycleUpsellHelper';
import { MonthlyExclusionsList } from './MonthlyExclusionsList';
import { monthlyNoteLinkProps } from './monthlyNoteLinkProps';
import { useSelectCycleFromMonthlyNote } from './useSelectCycleFromMonthlyNote';
export const CycleSelectorDisabledFeatures = _ref => {
  let {
    productId,
    mobile = false
  } = _ref;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  const selectCycle = useSelectCycleFromMonthlyNote();
  const showsUpsellNote = useShowsMonthlyUpsellNote();
  const linkProps = monthlyNoteLinkProps(mobile);
  const indentProps = mobile ? {} : {
    padding: '0 SP2 0 32px',
    boxSizing: 'border-box'
  };
  return /*#__PURE__*/React.createElement(Box, {
    borderRadius: "6px",
    direction: "vertical",
    width: "100%",
    gap: mobile ? 'SP2' : 'SP3'
  }, /*#__PURE__*/React.createElement(Box, _extends({}, indentProps, {
    direction: "vertical",
    width: "100%"
  }), /*#__PURE__*/React.createElement(MonthlyExclusionsList, {
    productId: productId,
    mobile: mobile
  })), showsUpsellNote ? /*#__PURE__*/React.createElement(MonthlyCycleUpsellHelper, {
    productId: productId,
    mobile: mobile
  }) : /*#__PURE__*/React.createElement(Box, _extends({}, indentProps, {
    direction: "vertical",
    width: "100%",
    gap: mobile ? 'SP2' : 'SP3'
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "cycle_entry.monthly_disclaimer.footer",
    components: {
      1: /*#__PURE__*/React.createElement(TextButton, _extends({
        size: "small"
      }, linkProps, {
        onClick: selectCycle(YEARLY_CYCLE_ID, 'select-1year-cycle')
      })),
      3: /*#__PURE__*/React.createElement(TextButton, _extends({
        size: "small"
      }, linkProps, {
        onClick: selectCycle(TWO_YEAR_CYCLE_ID, 'select-2year-cycle')
      }))
    }
  }))));
};
//# sourceMappingURL=CycleSelectorDisabledFeatures.js.map